var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.35 38.73",
    style: {
      enableBackground: "new 0 0 50.35 38.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.52,38.37c7.88,0,14.47-4.48,14.47-11.94c0-7.66-6.47-9.4-12.14-10.66l-0.63-0.14 c-0.1-0.02-0.21-0.05-0.31-0.07c-4.84-1.08-7.52-1.65-7.52-4.53c0-2.68,2.47-4.43,6.08-4.43c4.12,0,7,2.06,9.16,5.1l4.99-4.89 c-2.57-3.71-7.57-6.54-13.95-6.54C28,0.27,21.93,4.7,21.93,11.75c0,6.5,4.72,8.6,9.64,9.9l0.62,0.16c0.21,0.05,0.41,0.1,0.62,0.15 l0.61,0.15c5.56,1.24,9.06,1.7,9.06,5.1c0,3.14-2.83,4.84-6.69,4.84c-4.07,0-8.03-2.16-10.76-6.02l-5.2,5.05 C22.8,35.54,29.29,38.37,35.52,38.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.02,37.33V23.75h7.56c8.49,0,13.79-4.06,13.79-11.68c0-7.66-5.3-11.68-13.79-11.68H0.46v36.93H8.02z  M15.17,17.32H8.02V6.83h7.15c4.42,0,6.69,1.9,6.69,5.25C21.86,15.37,19.6,17.32,15.17,17.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo_symbol.8d8ba163176ebb6ae026fa301b4a8e15.svg";
export { ForwardRef as ReactComponent };